module.exports = __webpack_public_path__ + "img/葬爱-刀.f55d6c23.jpg";